import React from "react";
import {Typography} from "@mui/material";
import {Link, Box} from "@mui/material";

export const MetricsDetailFooter = () => {
    const date = new Date()

    return (
        <Box sx={styles.root}>
            <Box sx={styles.container}>
                <Box>
                    <Link href={'https://www.beremarkable.ai'} target="_blank" sx={styles.websiteLink}>
                        BeRemarkable.AI
                    </Link>
                </Box>

                <Box sx={styles.leftTextContainer}>
                    <Typography sx={styles.remarkableText}>
                        &copy; {date.getFullYear()} Remarkable
                    </Typography>
                    <Box sx={styles.legalTextContainer}>
                        <Link href={'https://www.beremarkable.ai/legal/privacy-policy'} target="_blank" sx={styles.legalLink}>
                            Privacy Policy
                        </Link>
                        <Link href={'https://www.beremarkable.ai/legal/terms'} target="_blank" sx={styles.legalLink}>
                            Terms of Service
                        </Link>
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}

const styles = {
    root: {
        px: { xs: 2, sm: 6 },
        mx: 'auto',
        maxWidth: '1344px',
        borderTop: '1px solid rgba(137, 159, 160, 0.25)',
        mt: 8,
        padding: '23px 48px',
    },
    container: {
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        justifyContent: 'space-between',
        alignItems: {sm: 'flex-start', md:'center'},
        gap: { xs: '10px', md: '15px' },
    },
    websiteLink: {
        color: '#302E2A',
        fontFamily: 'AzeretMonoRegular',
        fontSize: '10px',
        textDecoration: 'none',
        '&:hover': {
            color: '#302E2A',
        },
        '&:active': {
            color: '#302E2A',
        },
        '&:focus': {
            color: '#302E2A',
            outline: 'none',
        },
    },
    legalLink: {
        color: '#302E2A',
        fontFamily: 'FustatRegular',
        fontSize: '12px',
        textDecoration: 'none',
        '&:hover': {
            color: '#302E2A',
        },
        '&:focus': {
            color: '#302E2A',
            outline: 'none',
        },
    },
    legalTextContainer: {
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        justifyContent: { xs: 'flex-start', md: 'flex-end' },
        alignItems: { xs: 'flex-start', md: 'center' },
        gap:{ xs: '10px', md: '20px' },
    },
    remarkableText: {
        color: '#302E2A',
        fontFamily: 'FustatRegular',
        fontSize: '12px',
        margin: 0,
        textAlign: {xs: 'left', md: 'right'}
    },
    leftTextContainer: {
        textAlign: { xs: 'left', md: 'right' },
        display: 'flex',
        flexDirection: { md: 'column', xs: 'column-reverse' },
        justifyContent: 'space-between',
        gap: { xs: '10px', md: '5px' }
    },
}